import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {
    ButtonComponent,
    CheckboxComponent,
    IconComponent,
    InputComponent,
    InputGroupComponent,
    SpinnerComponent,
    TextareaComponent,
    OptionComponent,
    SelectComponent,
    TooltipDirective
} from '@epd/pattern-library';
import { NgIf, NgFor, NgClass, AsyncPipe, JsonPipe } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

import { streamingViewComponents } from './features/streaming-view-components';
import { ActiveConversationComponent } from './features/active-conversation/active-conversation.component';
import { LeftNavigationComponent } from './features/navigation/left-navigation.component';
import { StreamingViewComponent } from './root/streaming-view.component';
import { StreamingConversationHistoryComponent } from './features/conversation-history/streaming-conversation-history.component';
import { ActiveConversationService } from './features/active-conversation/active-conversation.service';
import { InstructionsPanelService } from './features/instructions/instructions-panel.service';
import { StreamingLeftNavigationService } from './features/navigation/left-navigation.service';
import { AuthClientService } from './features/auth-client/auth-client.service';
import { ConversationHistoryStorageService } from './features/conversation-history/conversation-history-storage.service';
import { RealtimeSessionStreamService } from './features/realtime-session-stream/realtime-session-stream.service';
import { CognitiveStateManagerService } from './features/realtime-session-stream/cognitive-state-manager.service';
import { CognitiveStreamProcessorService } from './features/realtime-session-stream/cognitive-stream-processor.service';
import { FeedbackStateManagerService } from './features/realtime-session-stream/feedback-state-manager.service';
import { ResponseFeedbackComponent } from './features/active-conversation/response-feedback/response-feedback.component';
import { StreamingConfigService } from './features/config/streaming-config.service';

// New services for refactored architecture
import { ConversationStateService } from './features/conversation-state/conversation-state.service';
import { MessageOperationsService } from './features/message-operations/message-operations.service';
import { SSEStreamHandlerService } from './features/sse-stream/sse-stream-handler.service';
import { StreamEventRouterService } from './features/stream-events/stream-event-router.service';
import { ConversationPersistenceService } from './features/conversation-persistence/conversation-persistence.service';

@NgModule({
    declarations: [...streamingViewComponents, StreamingViewComponent],
    imports: [
        MarkdownModule.forChild(),
        IconComponent,
        InputGroupComponent,
        InputComponent,
        ButtonComponent,
        CheckboxComponent,
        NgIf,
        NgFor,
        NgClass,
        AsyncPipe,
        JsonPipe,
        OptionComponent,
        SelectComponent,
        ReactiveFormsModule,
        FormsModule,
        SpinnerComponent,
        TextareaComponent,
        TooltipDirective,
        LeftNavigationComponent,
        HttpClientModule,
        ResponseFeedbackComponent,
        StreamingConversationHistoryComponent
    ],
    exports: [ActiveConversationComponent, LeftNavigationComponent, StreamingViewComponent],
    providers: [
        ActiveConversationService,
        InstructionsPanelService,
        StreamingLeftNavigationService,
        AuthClientService,
        ConversationHistoryStorageService,
        RealtimeSessionStreamService,
        CognitiveStateManagerService,
        CognitiveStreamProcessorService,
        FeedbackStateManagerService,
        StreamingConfigService,
        // New services for refactored architecture
        ConversationStateService,
        MessageOperationsService,
        SSEStreamHandlerService,
        StreamEventRouterService,
        ConversationPersistenceService
    ]
})
export class StreamingViewModule {}
